import React, { useState } from 'react';
import ConfigurationOverviewAccordion from '../ConfigurationOverviewAccordion/ConfigurationOverviewAccordion';
import {
  getTotalFormatted,
  getItemPriceFormatted,
  getSurchargePriceFormatted,
  getItemTitle,
} from '../../Reducers/Configurator/Selectors';
import { makeStyles } from '@material-ui/core/styles';
import { offwhite } from '../../Constants/Colors';
import Typography from '@material-ui/core/Typography';
import { useSelector } from 'react-redux';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import clsx from 'clsx';
import { Toolbar } from '../Toolbar/Toolbar';
import Button from '@material-ui/core/Button';
import { hidePrices } from '../../Helpers';
import AmountPriceContainer from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Containers/AmountPrice';
import PriceInfoDialog from '../PriceInfoDialog/PriceInfoDialog';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        padding: '0px 20px',
      },
    },
    priceOverViewLabel: {
      fontFamily: 'Inter',
      fontWeight: 500,
      fontSize: '17px',
      paddingTop: '69px',
      paddingBottom: '16px',
    },
    priceOverview: {
      display: 'flex',
      backgroundColor: offwhite,
      flexDirection: 'column',
      minHeight: '170px',
      justifyContent: 'space-evenly',
    },
    priceItem: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'row',
      padding: '0 30px',
    },
    priceLabel: {
      fontFamily: 'Inter',
      fontWeight: 300,
      fontSize: '15px',
    },
    price: {
      fontFamily: 'Inter',
      fontWeight: 300,
      fontSize: '15px',
      cursor: 'pointer',
    },
    bold: {
      fontWeight: 500,
    },
    footer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '40px 0',
    },
    ctaButton: {
      height: '50px',
      marginLeft: '30px',
      [theme.breakpoints.down('sm')]: {
        height: '40px',
        width: '160px',
        marginTop: '10px',
      },
    },
  }),
  {
    name: 'ConfigurationOverview',
  }
);

interface AmountPriceProps {
  openPriceOverview: () => void;
}

const ConfigurationOverview = () => {
  const classes = useStyles();
  const itemTitle = useSelector(getItemTitle);
  const itemPriceFormatted = useSelector(getItemPriceFormatted);
  const surchargePriceFormatted = useSelector(getSurchargePriceFormatted);
  const totalFormatted = useSelector(getTotalFormatted);
  const pricesHidden = hidePrices();
  const [requestOfferMode, setRequestOfferMode] = useState(false);
  const [showPriceInfo, setShowPriceInfo] = useState(false);
  const onPriceClick = () => {
    setShowPriceInfo(true);
  };

  const onCancelPriceInfo = () => {
    setShowPriceInfo(false);
  };
  return (
    <div className={classes.root}>
      <PriceInfoDialog onCancel={onCancelPriceInfo} open={showPriceInfo} />
      <ConfigurationOverviewAccordion />
      <Typography className={classes.priceOverViewLabel}>{t('overview.priceOverview')}</Typography>
      <div className={classes.priceOverview}>
        {!pricesHidden && (
          <div className={classes.priceItem}>
            <Typography className={classes.priceLabel}>{itemTitle}</Typography>
            <Typography onClick={onPriceClick} className={classes.price}>
              {itemPriceFormatted + '*'}
            </Typography>
          </div>
        )}
        {!pricesHidden && (
          <>
            <div className={classes.priceItem}>
              <Typography className={classes.priceLabel}>{t('overview.surcharge')}</Typography>
              <Typography onClick={onPriceClick} className={classes.price}>
                {surchargePriceFormatted + '*'}
              </Typography>
            </div>
            <div className={classes.priceItem}>
              <Typography className={clsx(classes.priceLabel, classes.bold)}>
                {t('overview.total')}
              </Typography>
              <Typography onClick={onPriceClick} className={clsx(classes.price, classes.bold)}>
                {totalFormatted + '*'}
              </Typography>
            </div>
          </>
        )}
      </div>
      <div className={classes.footer}>
        <Toolbar loadEnabled={false} />
        <AmountPriceContainer
          validateConfiguration={() => true /* skip validation */}
          showReceiveOfferForm={requestOfferMode}
          renderPriceBox={(props: AmountPriceProps) => (
            <div className={classes.ctaButtonContainer}>
              <Button
                className={classes.ctaButton}
                onClick={() => {
                  setRequestOfferMode(true);
                  props.openPriceOverview();
                }}
                variant="contained"
              >
                {t('overview.requestOffer')}
              </Button>
              <Button
                className={classes.ctaButton}
                onClick={() => {
                  setRequestOfferMode(false);
                  props.openPriceOverview();
                }}
                variant="contained"
              >
                {t('overview.toBasket')}
              </Button>
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default ConfigurationOverview;
